/**
 * Copyright (c) samjay.dev.
 *
 * Notes:
 * This source code is the private property of samjay.dev.
 * You cannot modify, share or copy these source codes without any formal authorization,
 * otherwise samjay.dev reserves the right to pursue any legal action.
 *
 * Developer: Sam Tsang (info@samjay.dev)
 */

import React from 'react'
import { getSvgIcon } from '../resources'
import NavStyle from '../scss/main/Nav.module.scss'
import SvgStyle from '../scss/main/Svg.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'store/types'
import { Action } from 'store/slices'
import { NavigateFunction, Params } from 'react-router-dom'

interface NavProps {
  currentPageName: string,
  currentPageNum: number,
  navTop?: boolean,
  toggleNav: boolean,
  goToHome: () => void,
  router: {
    location: Location;
    navigate: NavigateFunction;
    params: Readonly<Params<string>>;
  }
}

const goBack = (router: {
    location: Location;
    navigate: NavigateFunction;
    params: Readonly<Params<string>>;
  }, setBackStyle: (backStyle: boolean) => void) => {
  setBackStyle(false)
  router.navigate(-1)
}

const Nav: React.FC<NavProps> = ({
  router, currentPageName, currentPageNum, navTop, toggleNav, goToHome
}) => {

  const dispatch = useDispatch();
  const backStyle = useSelector((state: RootState) => state.ui.backStyle);
  const title = useSelector((state: RootState) => state.ui.title);
  
  const toggleMenu = () => {
    dispatch(Action.toggleNav({}))
  }
  
  const setBackStyle = (backStyle: boolean) => {
    dispatch(Action.setBackStyle({backStyle}))
  }

  return (
    <div className={`${NavStyle['nav']} ${navTop && !backStyle ? NavStyle['navTop'] : NavStyle['navTop']}`}>
      <div style={{ opacity: backStyle ? 1 : 0, transform: backStyle ? 'translateX(0px) translateZ(0px)' : 'translateX(-50px) translateZ(0px)' }} onClick={() => backStyle ? goBack(router, setBackStyle) : goToHome()}>
        <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'back' })}` }} />
        <div style={{ opacity: backStyle ? 1 : 0, transform: backStyle ? 'translateX(0px) translateZ(0px)' : 'translateX(-50px) translateZ(0px)' }} >
          <div>
            {title}
          </div>
        </div>
      </div>
      <div onClick={() => backStyle ? '' : goToHome()} style={{ cursor: backStyle ? 'auto' : 'pointer', display: backStyle ? 'none' : 'unset' }} dangerouslySetInnerHTML={{__html: `${getSvgIcon({ name: 'logo' })}` }} />
      <div onClick={toggleMenu}>
        <div>
          <div>
            <div>
              {toggleNav ? "Close" : currentPageName}
            </div>
          </div>
        </div>
        <div>
          <div>
            <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'line1' })}` }} />
            <div style={{display: toggleNav ? 'none' : 'flex'}} dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'line2' })}` }} />
            <div style={{display: toggleNav ? 'none' : 'flex'}} dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'line3' })}` }} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Nav